// src/pages/Streaming/StreamingService.js

import ApiService from "../../services/api-service";

class StreamingService {
  /**
   * Start a livestream.
   * Merges user-specified fields with defaults for required fields.
   */
  static async startLiveStream(payload) {
    try {
      // Merge your original payload with mandatory fields
      // (platform = "hedera", isNew = true)
      const finalPayload = {
        ...payload,
        platform: "web",
        isNew: true,
      };

      console.log("Start Live Stream with finalPayload:", finalPayload);

      // Call your back-end API
      const response = await ApiService.LIVESTART(finalPayload);

      // The back end returns { status, code, message, result } at top level
      if (response?.status === "success" && response?.result) {
        // Return a standardized object
        return {
          success: true,
          data: response.result, // e.g., { token, channelName, appId, etc. }
        };
      }

      const serverMessage = response?.message;
      return {
        success: false,
        message: serverMessage || "Failed to start livestream",
      };
    } catch (error) {
      console.error("Error starting livestream:", error);
      return {
        success: false,
        message: error?.response?.data?.message || error?.message || "Failed to start livestream",
      };
    }
  }

  // Join a livestream

  static async joinLiveStream(payload) {
    try {
      // Call your back-end API
      const response = await ApiService.LIVEJOIN(payload);
  
      // Check for HLS response (no token needed) or standard RTC response
      if (
        response?.status === "success" &&
        (response?.result?.useHls || response?.result?.obsAdmin || (response?.result?.token && response?.result?.channelName))
      ) {
        return {
          success: true,
          data: response.result,
        };
      } else {
        return {
          success: false,
          message: response?.message || "Failed to join livestream",
        };
      }
    } catch (error) {
      console.error("Error joining livestream:", error);
      return {
        success: false,
        message: "Failed to join livestream",
      };
    }
  }

  static async exitLiveStream(payload) {
    try {
      console.log("Exit Live Stream with payload:", payload);
  
      const response = await ApiService.LIVEEXIT(payload);
  
      if (response?.status !== "success" || !response?.result) {
        throw new Error("No result returned from API");
      }
  
      return {
        success: true,
        data: response.result,
      };
    } catch (error) {
      console.error("Error exiting livestream:", error);
      return {
        success: false,
        message: "Failed to exit livestream",
      };
    }
  }
  
  
  

  /**
   * End a livestream.
   * `forceful` skips the server's 15s host-disconnect grace so an explicit
   * user-initiated End cannot be undone by an auto-rejoin path.
   */
  static async endLiveStream(channelName, { forceful = true } = {}) {
    try {
      console.log("End Live Stream with channelName:", channelName, "forceful:", forceful);

      const response = await ApiService.LIVEEND({ channelName, forceful });

      if (response?.status !== "success" || !response?.result) {
        throw new Error("No result returned from API");
      }

      return {
        success: true,
        data: response.result,
      };
    } catch (error) {
      console.error("Error ending livestream:", error);
      return {
        success: false,
        message: "Failed to end livestream",
      };
    }
  }
}

export default StreamingService;
